/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import TextInput from "ui/kit/input/TextInput";
import {useDebounce} from "react-use";

interface Props {
    initialText: string;
    performSave: (val: string) => Promise<void>
}

const PieceSettingsDebouncedItem: React.FC<Props> = ({initialText, performSave}) => {

    const [text, setText] = React.useState<string>(initialText);

    const executeSave = React.useCallback(async () => {
        await performSave(text);
    }, [performSave, text])

    const onTextChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setText(e.target.value)
    }, [setText])

    useDebounce(async () => {
        await executeSave();
    }, 1000, [executeSave]);

    return (
        <div>
            <TextInput value={text} onChange={onTextChange}/>
        </div>
    )
}

export default PieceSettingsDebouncedItem;